import { useEffect, useState, useRef } from "react"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../firebase/config"

export const useCollection = (c, _q, _orderBy) => {
  const [documents, setDocuments] = useState(null)
  const [error, setError] = useState(null)

  const q = useRef(_q).current
  const orderBy = useRef(_orderBy).current

  useEffect(() => {
    let ref = collection(db, c)

    if (q) {
      ref = query (ref, where(...q))
    }


    const unsub = onSnapshot(ref, (snapshot) => {
      let results = []
      snapshot.docs.forEach(doc => {
        results.push({...doc.data(), id: doc.id})
      })
      setDocuments(results)
    })

    return () => unsub()
  }, [c])
    return {documents}
  }